module.exports = __webpack_public_path__ + "img/orange-btn.b2aeb18.png";